t = require('views/internal/teacup-with-helpers')()

module.exports = t.renderable ({ members }) ->
  for { avatarHash, fullName, username, initials, icon } in members
    t.span '.edit-in-progress', ->
      t.span '.inline-member', ->
        title = "#{ fullName } (#{ username })"
        if avatarHash
          t.img '.inline-member-av', { src: [window.avatarDomain, avatarHash, '30.png'].join('/'), alt: title, title }
        else
          t.span '.quiet.initials', { title }, ->
            t.text initials
      if icon
        t.icon icon, class: 'icon'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/edit_in_progress.coffee